import { createStructuredSelector } from 'reselect';
import {
    EMPLOYEE_LIST,
    EMPLOYEE_LIST_SUCCESS,
    EMPLOYEE_LIST_ERROR,
    EMPLOYEE_PAGE_SET,
    EMPLOYEE_DETAIL,
    EMPLOYEE_DETAIL_SUCCESS,
    EMPLOYEE_DETAIL_ERROR,
    EMPLOYEE_VIEW_MODAL_SET,
    EMPLOYEE_ADD_MODAL_SET,
    EMPLOYEE_ADD,
    EMPLOYEE_ADD_SUCCESS,
    EMPLOYEE_ADD_ERROR,
    EMPLOYEE_ADD_CHANGE,
    EMPLOYEE_EDIT_MODAL_SET,
    EMPLOYEE_EDIT_SET,
    EMPLOYEE_EDIT_CHANGE,
    EMPLOYEE_UPDATE,
    EMPLOYEE_UPDATE_SUCCESS,
    EMPLOYEE_UPDATE_ERROR
} from '../actions';

export const EmployeeList = (page, num_page) => ({
    type: EMPLOYEE_LIST,
    payload: { page, num_page }
});

export const EmployeeListSuccess = (data) => ({
    type: EMPLOYEE_LIST_SUCCESS,
    payload: data
});

export const EmployeeListError = (error) => ({
    type: EMPLOYEE_LIST_ERROR,
    payload: error
});

export const EmployeePageSet = (data) => ({
    type: EMPLOYEE_PAGE_SET,
    payload: data
});

export const EmployeeDetail = (data) => ({
    type: EMPLOYEE_DETAIL,
    payload: data
});

export const EmployeeDetailSuccess = (data) => ({
    type: EMPLOYEE_DETAIL_SUCCESS,
    payload: data
});

export const EmployeeDetailError = (error) => ({
    type: EMPLOYEE_DETAIL_ERROR,
    payload: error
});

export const EmployeeViewModalSet = (data) => ({
    type: EMPLOYEE_VIEW_MODAL_SET,
    payload: data
});

export const EmployeeAddModalSet = (data) => ({
    type: EMPLOYEE_ADD_MODAL_SET,
    payload: data
});

export const EmployeeAddAction = (data) => ({
    type: EMPLOYEE_ADD,
    payload: data
});

export const EmployeeAddSuccess = (data) => ({
    type: EMPLOYEE_ADD_SUCCESS,
    payload: data
});

export const EmployeeAddError = (error) => ({
    type: EMPLOYEE_ADD_ERROR,
    payload: error
});

export const EmployeeAddChangeSet = (data) => ({
    type: EMPLOYEE_ADD_CHANGE,
    payload: data
});

export const EmployeeEditModalSet = (data) => ({
    type: EMPLOYEE_EDIT_MODAL_SET,
    payload: data
});

export const EmployeeEditSet = (data) => ({
    type: EMPLOYEE_EDIT_SET,
    payload: data
});

export const EmployeeEditChangeSet = (data) => ({
    type: EMPLOYEE_EDIT_CHANGE,
    payload: data
});

export const EmployeeUpdateAction = (data) => ({
    type: EMPLOYEE_UPDATE,
    payload: data
});

export const EmployeeUpdateSuccess = (data) => ({
    type: EMPLOYEE_UPDATE_SUCCESS,
    payload: data
});

export const EmployeeUpdateError = (error) => ({
    type: EMPLOYEE_UPDATE_ERROR,
    payload: error
});

const employee = (state) => state.employee;

export const EmployeeSelector = createStructuredSelector({ employee });
